import { render } from "./MyWorkTripleDropdownTooltip.vue?vue&type=template&id=93a803f4&ts=true"
import script from "./MyWorkTripleDropdownTooltip.vue?vue&type=script&lang=ts"
export * from "./MyWorkTripleDropdownTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__